import classNames from 'classnames'
import React from 'react'
import Icon from 'src/components/forms/icon/icon'
import { CLASS_PREFIX } from 'src/constants/'

import './tag.scss'

type Props = {
  text: string;
  onRemove?: React.MouseEventHandler<HTMLButtonElement>;
  onClick?: React.MouseEventHandler<HTMLSpanElement>;
  gradient?: boolean;
  className?: string;
};

const cls = `${CLASS_PREFIX}tag`

export const Tag: React.FC<Props> = ({
  text,
  onRemove,
  onClick,
  gradient,
  className
}) => {
  const classes = classNames(
    {
      [`${cls}__clickable`]: !!onClick,
      [`${cls}__gradient`]: !!gradient,
      [`${cls}__basic`]: !gradient
    },
    className
  )

  return (
    <span onClick={onClick} className={classes}>
      {text}
      {onRemove && (
        <button
          type="button"
          className={`${cls}__remove-button`}
          onClick={onRemove}
          aria-label={`Remove ${text} tag`}
        >
          <Icon name="thin-x" size={12} />
        </button>
      )}
    </span>
  )
}
